import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Subclass from '@/components/Subclass'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/subclass',
      name: 'subclass',
      component: Subclass
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js